import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { SET_ACCESS_ERROR } from 'redux/slices/authentication';
import MainFont from 'ui/typography/mainFont';
import { ErrorWrapper, ForgotPasswordTitle } from './style';
import { ManagePersonalData } from 'ui/components';

const AddPersonalData = ({ genericError, updateUserData }) => {
  const { t } = useTranslation();

  return (
    <>
      <ErrorWrapper createPassword>
        {genericError && <MainFont type="errorLabel">{genericError}</MainFont>}
      </ErrorWrapper>
      <ForgotPasswordTitle onManagePersonalData>
        <MainFont configuration={{ fontSize: 24 }} type="3">
          {t('complete_personal_data')}
        </MainFont>
      </ForgotPasswordTitle>
      <ManagePersonalData isOnLoginFlow />
    </>
  );
};

AddPersonalData.propTypes = {
  genericError: PropTypes.string,
  updateUserData: PropTypes.func
};

export default connect(
  ({ authentication }) => ({
    genericError: authentication.errorMessage
  }),
  dispatch => ({
    setError: payload => dispatch(SET_ACCESS_ERROR(payload))
  })
)(AddPersonalData);
